import Content from "./content";
import DetailPois, { IDetailPoisAnalytics } from "~/ui/review/detailPois";
import { isInViewport, node } from "~/util/dom";
import { getDetailPois } from "~/util/providers/review";
import { useScroll } from "~/util/usescroll";
import { _ } from "~/i18n";
import { IPoi } from "~/interfaces";
import { firmStats, isFirmFromPoi } from "~/util/review";

export default class DetailPoisContent extends Content<IPoi> {
	_wasRequest: boolean;

	_scrollListener: ReturnType<typeof useScroll>;

	destroy() {
		this._cancelScroll();
	}

	_cancelScroll() {
		this._scrollListener && this._scrollListener();
		this._scrollListener = null;
	}

	_isVisible() {
		return isInViewport(this._dom.container);
	}

	_build() {
		this._dom.container.classList.add("content-detail-pois");
		this._wasRequest = false;
		this._scrollListener = useScroll({
			onScroll: () => {
				if (!this._wasRequest && this._isVisible()) {
					this.load();
				}
			},
		});
	}

	async load() {
		const loader = node("div", { className: "content-detail-pois__loader" });
		const loaderImg = node("img", { src: "/img/loader.gif", width: 24, height: 24 });

		loader.append(loaderImg);

		this._dom.container.append(loader);

		this._wasRequest = true;

		this._cancelScroll();

		try {
			const data = await getDetailPois({
				source: this._data.source,
				id: this._data.id as number,
				forceTranslation: true,
			});

			loader.remove();

			if (data.pois.length > 0) {
				const detailPois = new DetailPois({
					pois: data.pois,
					onAnalytics: (event, eventData) => {
						if (event === "load" || event === "click") {
							const name = event === "load"
								? "regi_reviews_impress"
								: "click";
							const logData = {
								detailSource: this._data.source,
								detailTypeid: this._data.typeId,
								detailId: this._data.id,
								...event === "load"
									? {
										regiPOI: {
											...eventData as IDetailPoisAnalytics["load"],
										},
										detailName: this._data.titleVars.titleMain,
									}
									: {},
								...event === "click"
									? {
										text: "regiPOI",
										index: (eventData as IDetailPoisAnalytics["click"]).index,
										poiSource: (eventData as IDetailPoisAnalytics["click"]).item.source,
										poiTypeid: (eventData as IDetailPoisAnalytics["click"]).item.description.typeId,
										poiId: (eventData as IDetailPoisAnalytics["click"]).item.id,
									}
									: {},
							};

							Mapy.getComponent("logger").log(name, logData);

							if (event === "click") {
								// jdeme na detail
								const clickData = eventData as IDetailPoisAnalytics["click"];

								if (isFirmFromPoi(clickData.item as any)) {
									firmStats("firmy-vizitka-akce", clickData.item.description as any, { placeId: 38, typeId: 7 });
								}

								Mapy.getComponent("detail").setState({
									source: clickData.item.source,
									id: clickData.item.id,
									show: true,
								}).then(() => {
									Mapy.getComponent("history").save();
								}, () => {});
							}
						} else if (event === "show") {
							const showData = eventData as IDetailPoisAnalytics["show"];

							if (isFirmFromPoi(showData.item as any)) {
								firmStats("firmy-vizitka-doruceni", showData.item.description as any, { placeId: 38 });
							}
						}
					},
				});

				this._dom.container.append(
					node("h3", { className: "content-detail-pois__title", textContent: _("review.peopleAlsoVisited") }),
					detailPois.node,
				);
			}
		} catch (exc) {
			loader.remove();
		}
	}
}
